import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ArchivedFilterEnum,
	getPropertyV2,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePropertyListQuery = (
	filterDatagroups?: PortfolioReportingOverviewTypeEnum[],
	filterOnlyreportingenabled?: boolean,
	filterArchived?: ArchivedFilterEnum,
	enabled = true,
) => {
	return useQuery({
		queryKey: PortfolioKeys.propertyList(
			filterDatagroups,
			filterOnlyreportingenabled,
			filterArchived,
		),
		queryFn: ({ signal }) =>
			processResponse(() =>
				getPropertyV2(
					filterDatagroups,
					filterOnlyreportingenabled,
					filterArchived,
					{ signal },
				),
			)(undefined),
		enabled,
	});
};
